// extracted by mini-css-extract-plugin
export default {"bio":"z5","about":"A5","title":"B5","text":"C5","fun_facts":"E5","fun":"F5","icon":"G5","bio_header":"H5"};
    if(module.hot) {
      // 1738064244027
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  